import React, { useState, useEffect, FormEvent, ChangeEvent, useRef } from 'react'

import axios from 'axios'
import { API_URL, config } from '../components/Include';
import { Alerts } from '../components/notify';

const ConfirmEmail =()=> {

  const [errors, setErrors] = useState({
    
    is_loading:false,
    successMessage:'',
    errorMessage:''

});
const [mounted, setMounted] = useState(false);
  
  function verifyLink(){  
		    
    var query = new URLSearchParams(window.location.search)
    let myemail:any = query.get("myemail")
   let mytoken:any = query.get("mytoken")
      
    if(!myemail || !mytoken || myemail==='null'  || mytoken==='null' || mytoken==='' || myemail===''){
        window.open('/', '_self')
    
    }else{
      setErrors({...errors, is_loading:true})
       
          const fd = new FormData();
          fd.append('email', myemail)
          fd.append('token', mytoken)
    
          let url = API_URL+'/applicant_mail/confirm_email';
          axios.post(url, fd, config)
          .then(response =>{
            if(response.data.status === 200){
              setErrors({...errors, successMessage: response.data.message, is_loading:false})
              
          }else if (response.data.type ==='error'){
            Alerts('danger', response.data.message, 'Something went wrong!')
            setErrors({...errors, is_loading:false})
                  setTimeout(() => {
                  window.open('/', '_self')
                   }, 3000);
          }    
        })
        .catch((error)=>{
          setErrors({...errors, errorMessage: error.message, is_loading:false})
  
           setTimeout(() => {
          window.open('/', '_self')
           }, 3000);
        })  
        } 
    }
   
  useEffect(()=>{ 
    if (mounted) {
      verifyLink() 
      
    }
    setMounted(true)
  },[mounted]); 

  return (
   <>
    {errors.is_loading?
      <div className='overlay' >
                <img src="/images/loader.svg" alt="loader" />
        </div> :''}
    <section className="choose-section pt-0" id="services"> 
   
    <div className="container"> 
 
    
 <div className="row float-center">
 
 {errors.successMessage?
 <div className="alert alert-secondary d-flex" role="alert">

   <i className="ri-error-warning-fill align-middle fs-27 me-2" aria-hidden="true"></i> 

   <p className="my-auto ">{errors.successMessage}</p> 

   <button type="button" className="close text-secondary ms-auto mb-auto" data-bs-dismiss="alert" aria-hidden="true"><i className="ri-close-line"></i></button> 
   
   </div>:''}
 </div>
    
    
    </div>
    
     </section> 
     </>
  )
}

export default ConfirmEmail